var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularCourse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2499 18.5001C15.4027 18.5001 19.5799 14.4707 19.5799 9.50012C19.5799 4.52956 15.4027 0.500122 10.2499 0.500122C5.09711 0.500122 0.919922 4.52956 0.919922 9.50012C0.919922 14.4707 5.09711 18.5001 10.2499 18.5001ZM15.3931 7.31137C15.6754 7.04728 15.6902 6.60431 15.4261 6.32198C15.162 6.03964 14.719 6.02486 14.4367 6.28895L9.14195 11.2417L6.99607 9.23441C6.71374 8.97031 6.27077 8.9851 6.00667 9.26743C5.74258 9.54977 5.75736 9.99273 6.0397 10.2568L8.66376 12.7114C8.93286 12.9631 9.35103 12.9631 9.62013 12.7114L15.3931 7.31137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularCourse);
export default __webpack_public_path__ + "static/media/popular_course.9afdc3462ab73e3326a46fb810f0547d.svg";
export { ForwardRef as ReactComponent };